<template>
  <div
    v-if="isRatingVisble()"
    class="fe-flex fe-items-center fe-gap-xs lg:fe-gap-s fe-text-body-xxs-bold lg:fe-text-body-m-bold fe-cursor-pointer"
    @click="moveToReviewBinding"
  >
    <div v-if="currentVertical.netmeds" class="fe-text-primary-grey-80">
      {{ averageRating }}
    </div>
    <div>
      <StarRating
        :readOnly="true"
        :initialRating="averageRating"
        :partialSupport="true"
        smSize="s"
        lgSize="m"
      />
    </div>
    <div v-if="currentVertical.netmeds" class="fe-text-primary-60">
      {{ pluralizeRatingText }}
    </div>
    <div v-else class="fe-text-primary-60">
      {{ totalRatingCount }}
    </div>
  </div>
</template>

<script>
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"
  import {
    BINDING_ELEMENT_ID,
    FYND_DEFAULT_HEADER_CLASSNAME,
  } from "@/constants/constants"
  import {
    checkCurrentVerticals,
    checkIsMobile,
    pluralize,
  } from "@/utils/utils"

  export default {
    name: "AverageRating",
    components: { StarRating },
    inject: ["globalState"],
    computed: {
      pluralizeRatingText() {
        return `(${this.totalRatingCount} ${pluralize("Rating", this.totalRatingCount)})`
      },
      averageRating() {
        return this.globalState.avgRating || 0
      },
      totalRatingCount() {
        return this.globalState.ratingsCount || 0
      },
      currentVertical() {
        return checkCurrentVerticals()
      },
      isScreenMobile() {
        return checkIsMobile()
      },
    },
    methods: {
      moveToReviewBinding() {
        const element = document.getElementById(
          BINDING_ELEMENT_ID.REVIEW_AND_RATING,
        )

        if (!element) return

        // Get the bounding rectangle of the target element
        const elementRect = element.getBoundingClientRect()

        // Get the Fixed/Sticky positioned Header offset height
        const headerElementHeight =
          document.querySelector(`.${FYND_DEFAULT_HEADER_CLASSNAME}`)
            ?.offsetHeight || 0

        const elementScrollPosition =
          window.scrollY + elementRect.top - headerElementHeight

        // Scroll to the calculated element position
        window.scrollTo({
          top: elementScrollPosition,
          behavior: "smooth",
        })
      },
      isRatingVisble() {
        if (!this.currentVertical.netmeds) {
          return true
        }

        if (this.totalRatingCount) {
          return true
        }

        return false
      },
    },
  }
</script>
